import React from 'react';
import { useIntl } from "react-intl";
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/styles';
import PropTypes from "prop-types";
import {
  Typography,
} from "@material-ui/core";

import {
  FormTextField,
} from '../../../../components';
import { getI18n } from "../../../../utils/intl";
import styles from './styles';

export const TCDescription = (params) => {
  const { classes, description, onDescriptionChange } = params;
  const intl = getI18n(useIntl());

  return (
    <div
      className={classes.descriptionField}
      data-apim-test="tc-description-div"
    >
      <Typography variant="h4" className={classes.pageTitle}>
        {intl.getI18nMessage("label.category.details.description.public.description")}
      </Typography>
      <FormTextField
        defaultValue=""
        handleChange={onDescriptionChange}
        id="tc-description"
        label="Description"
        maxLength={255}
        multiline
        helperText={intl.getI18nMessage('label.category.details.description.public.description.help.text')}
        rows={10}
        value={description}
        variant="outlined"
      />
    </div>
  );
};
  
const mapStateToProps = () => ({
});

const mapDispatchToProps = {
};

TCDescription.propTypes = {
  classes: PropTypes.object,
  description: PropTypes.string,
  onDescriptionChange: PropTypes.func,
};

TCDescription.displayName = 'TCDescription';

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(TCDescription);
